export const DESKTOP_BREAKPOINT = 1075;
export const TABLET_BREAKPOINT = 768;
export const DATEPICKER_MIN_YEAR = 1900;
export const DATEPICKER_MAX_YEAR = 2100;
// Caducidad del DNI permanente (mayores): 01-01-9999. El datepicker solo llega a 2100.
export const PERMANENT_DNI_EXPIRATION_YEAR = 9999;
export const PERMANENT_DNI_EXPIRATION_MONTH = 1;
export const PERMANENT_DNI_EXPIRATION_DAY = 1;
